module.exports = __webpack_public_path__ + "static/img/z-4.39000368.png";